// Web-only strings for the destinations feature (keys prefixed `web.destinations.`), BOTH languages.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.destinations.loading': 'Cargando…',
    'web.destinations.threads.unavailable.title': 'Los hilos no están disponibles',
    'web.destinations.threads.unavailable.body': 'Este servidor no tiene activados los hilos contraídos.',
    'web.destinations.threads.refreshFailed': 'No se pudieron actualizar los hilos.',
    'web.destinations.threads.loadingOlder': 'Cargando hilos anteriores…',
    'web.destinations.mentions.searching': 'Buscando menciones en el servidor…',
    'web.destinations.saved.refreshFailed': 'No se pudieron actualizar los guardados — se muestra lo que hay en este dispositivo.',
    'web.destinations.saved.unsaveFailed': 'No se pudo quitar de guardados.',
  },
  en: {
    'web.destinations.loading': 'Loading…',
    'web.destinations.threads.unavailable.title': 'Threads are not available',
    'web.destinations.threads.unavailable.body': 'Collapsed reply threads are not turned on for this server.',
    'web.destinations.threads.refreshFailed': "Couldn't refresh threads.",
    'web.destinations.threads.loadingOlder': 'Loading older threads…',
    'web.destinations.mentions.searching': 'Searching the server for mentions…',
    'web.destinations.saved.refreshFailed': "Couldn't refresh saved messages — showing what's on this device.",
    'web.destinations.saved.unsaveFailed': "Couldn't remove from saved.",
  },
};
